// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__DeletePopup__deactivatePopup{width:45%}.app__DeletePopup__bold{font-weight:700;padding:0 4px}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/ent-capability-billing-react/DeletePopup/DeletePopup.module.scss"],"names":[],"mappings":"AAAA,mCACI,SAAA,CAGJ,wBACI,eAAA,CACA,aAAA","sourcesContent":[".deactivatePopup {\n    width: 45%;\n} \n\n.bold {\n    font-weight: bold;\n    padding: 0px 4px 0px 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"deactivatePopup": "app__DeletePopup__deactivatePopup",
	"bold": "app__DeletePopup__bold"
};
export default ___CSS_LOADER_EXPORT___;
